export default __webpack_public_path__ + "images/logo/header-logo-8fe9fc764feb93c8c7e0d6105aea6610.svg";